/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityState } from '../models/EntityState';
import type { Pagination1OfAuditEntryAdminDto } from '../models/Pagination1OfAuditEntryAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditEntriesService {
    /**
     * **Required Policy:** `ViewActivityLogs`
     * @returns Pagination1OfAuditEntryAdminDto OK
     * @throws ApiError
     */
    public static getActivityLogsAdmin({
        entityName,
        entityId,
        userId,
        state,
        startTimeFrom,
        startTimeTo,
        isSucceeded,
        page,
        limit,
    }: {
        entityName: string,
        entityId: string,
        userId?: string,
        state?: EntityState,
        startTimeFrom?: string,
        startTimeTo?: string,
        isSucceeded?: boolean,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfAuditEntryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/auditentries',
            query: {
                'entityName': entityName,
                'entityId': entityId,
                'userId': userId,
                'state': state,
                'startTimeFrom': startTimeFrom,
                'startTimeTo': startTimeTo,
                'isSucceeded': isSucceeded,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
